import { IOfficeField, OfficeFieldWebInputTypeEnum } from '@pages/office/models/office-data.model';
import { FormFieldControlType, FormFieldControlTypeEnum } from '@pages/office/models/office-form.model';

export class FormFieldHelper {
  static getControlTypeByWebInputType(type: IOfficeField['WebInputType']): FormFieldControlType {
    switch (type) {
      case OfficeFieldWebInputTypeEnum.string:
      case OfficeFieldWebInputTypeEnum.web:
      case OfficeFieldWebInputTypeEnum.email:
        return FormFieldControlTypeEnum.text;
      case OfficeFieldWebInputTypeEnum.byte:
      case OfficeFieldWebInputTypeEnum.short:
      case OfficeFieldWebInputTypeEnum.int:
      case OfficeFieldWebInputTypeEnum.double:
      case OfficeFieldWebInputTypeEnum.long:
        return FormFieldControlTypeEnum.number;
      case OfficeFieldWebInputTypeEnum.radiobutton:
        return FormFieldControlTypeEnum.combobox;

      default:
        return FormFieldControlTypeEnum[type];
    }
  }
}
